<script>
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
export default {
  name: "VideoSection",
  methods: {
    once(el, event, fn, opts=null) {
        let onceFn = function (e) {
            el.removeEventListener(event, onceFn)
            fn.apply(this, arguments)
        }
        el.addEventListener(event, onceFn, opts)
        return onceFn
    },
    desktopVideo() {
        const video = document.getElementById('v1')
        let src = video.currentSrc || video.src

        this.once(document.documentElement, 'touchstart', function (e) {
            video.play()
            video.pause()
        })


        let tl = gsap.timeline({
            defaults: { duration: 1 },
            scrollTrigger: {
                trigger: '.video-wrap',
                pin: '.video-pin',
                start: 'center center',
                end: '+=3000',
                scrub: 0.5
            }
        })

        this.once(video, 'loadedmetadata', () => {
            tl.fromTo(
                video,
                {
                    currentTime: 0
                },
                {
                    currentTime: (video.duration - 0.05) || 0.95
                }
            )
        })
        let self = this
        setTimeout(function () {
            if (window['fetch']) {
                fetch(src)
                    .then((response) => response.blob())
                    .then((response) => {
                        self.once(document.documentElement, 'touchstart', function (e) {
                            video.play()
                            video.pause()
                        })
                    })
            }
        }, 1000)
    },
    mobileVideo() {
        const video = document.getElementById('v2')
        let src = video.currentSrc || video.src

        this.once(document.documentElement, 'touchstart', function (e) {
            video.play()
            video.pause()
        })


        let frameNumber = 0
        let tl = gsap.timeline({
            defaults: { duration: 1 },
            scrollTrigger: {
                trigger: '.video-wrap',
                start: 'center center',
                end: '+=3000',
                scrub: 0.5
            }
        })

        this.once(video, 'loadedmetadata', () => {
            tl.fromTo(
                video,
                {
                    currentTime: 0
                },
                {
                    currentTime: (video.duration - 0.05) || 0.95
                }
            )
        })
        let self = this
        setTimeout(function () {
            if (window['fetch']) {
                fetch(src)
                    .then((response) => response.blob())
                    .then((response) => {
                       self.once(document.documentElement, 'touchstart', function (e) {
                            video.play()
                            video.pause()
                        })
                    })
            }
        }, 1000)
    }
  },
  mounted() {
    gsap.registerPlugin(ScrollTrigger)
    this.desktopVideo()
    this.mobileVideo()
  }
}
</script>
<template>
  <div class="video-pin">
    <article class="section">
        <div class="container px-0 px-sm-1">
            <div class="video-wrap-outer position-relative">
                <div class="video-wrap position-relative">
                    <div class="video-wrap-inner">
                        <video id="v1" tabindex="0" src="/static/videos/vid5_23.mp4" autobuffer="autobuffer" preload="preload" playsinline="true" webkit-playsinline="true">
                        </video>
                    </div>
                </div>

                <div class="mockup-wrap-outer position-absolute">
                    <img
                        src="/static/images/iphone-mockup.png"
                        class="img-fluid position-relative"
                        alt=""
                    />
                    <div class="mockup-wrap-inner position-absolute">
                        <div class="mockup-video">
                            <video id="v2" tabindex="0" src="/static/videos/vid-mob5_23_640.mp4" autobuffer="autobuffer" preload="preload" playsinline="true" webkit-playsinline="true">
                        </video>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </article>
  </div>
</template><style lang="scss" scoped>
@import '../../sass/abstracts/_mixins.scss';
.video-pin {
  @include media-breakpoint-down(md) {
    height: 120% !important;
    max-height: 120% !important;
  }
}
.mockup-wrap-outer {
    max-width: 46rem;
    left: 50%;
    width: 100%;
    transform: translateX(-50%);
    bottom: -8rem;
    z-index: 10;
    @include media-breakpoint-down(md) {
        bottom: -7rem;
        width: 92%;
    }
    @include media-breakpoint-down(sm) {
        bottom: -5rem;
        width: 92%;
    }

    img {
        z-index: 2;
    }

    .mockup-wrap-inner {
        width: 100%;
        height: 100%;
        inset: 0;
        overflow: hidden;
        border-radius: 5.3rem;
        z-index: 1;
        padding: 0.6rem;

        @include media-breakpoint-down(sm) {
            border-radius: 2.5rem;
            padding: 0.4rem;
        }

        @media (max-width: 400px) {
            transform: scale(1.02);
        }

        @include media-breakpoint-only(sm) {
            border-radius: 3rem;
        }
    }

    .mockup-video {
        width: 100%;
        height: 100%;
        position: relative;

        video {
            position: absolute;
            inset: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
}
.video-wrap {
    border: 0.6rem solid #e9e9e9;
    border-radius: 1.7rem;
    overflow: hidden;
    width: 100%;
    height: auto;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    background-color: #e9e9e9;
    video {
        width: 100%;
        min-height: 100%;
        overflow: hidden;
    }
}

.video-wrap-inner {
    border-radius: 0.8rem;
    overflow: hidden;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
}

.video-wrap-outer::after {
    content: '';
    width: 100%;
    height: 30%;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #fff 90%);

    @include media-breakpoint-down(md) {
        height: 50%;
    }
}
</style>